export default __webpack_public_path__ + "static/media/playstore.9f0c4980.svg";